import apiService from '../apiService';

const URL = 'letter-templates';

const fail = (error) => {
  throw error?.response?.data || error;
};

const letterTemplateService = {
  /** Active templates for pickers; pass { matter_id } to limit to ones usable on that matter. */
  async list(params = {}) {
    try {
      const response = await apiService.get(`/${URL}`, { params });
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async mergeFields(recordTypeId = null) {
    try {
      const response = await apiService.get(`/${URL}/merge-fields`, {
        params: recordTypeId ? { record_type_id: recordTypeId } : {},
      });
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async get(id) {
    try {
      const response = await apiService.get(`/${URL}/${id}`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async create(payload) {
    try {
      const response = await apiService.post(`/${URL}`, payload);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async update(id, payload) {
    try {
      const response = await apiService.put(`/${URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async remove(id) {
    try {
      const response = await apiService.delete(`/${URL}/${id}`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async duplicate(id) {
    try {
      const response = await apiService.post(`/${URL}/${id}/duplicate`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async preview(id, payload) {
    try {
      const response = await apiService.post(`/${URL}/${id}/preview`, payload);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },
};

export default letterTemplateService;
